import React from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'oidc-react';
import ApprovalFromEmailModal from '../../components/patchCenter/ApprovalFromEmailModal';
import PatchCenterPage from './patchcenter';

const ApproveFromEmail = () => {
  const { planId } = useParams<{ planId: string }>();
  const auth = useAuth();

  useEffect(() => {
    if (planId) {
      sessionStorage.removeItem('pendingApprovalPlanId');
    }
  }, [planId]);

  // Redirect to login if not authenticated
  if (!auth?.userData) {
    window.location.href = '/login';
    return null;
  }

  if (!planId) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-[#1e1e1e] text-white rounded-lg p-8 text-center">
          <p className="text-red-400">Invalid plan ID. Please check the link and try again.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <PatchCenterPage />
      <ApprovalFromEmailModal planId={planId} />
    </>
  );
};

export default ApproveFromEmail;
